// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"39ec9281","784":"5ef635ef"}[chunkId] + ".chunk.css";
};